import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import '../../css/style.css';
import '../Home.css';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { BOOKING_TYPES } from '../../backend/Data';


registerLocale('de', de)


class PublicEventAddDetail extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.handleBookingChange = this.handleBookingChange.bind(this);


        this.state = {
            validated: false,
            event: this.props.detailModel
        };
    }

    handleChange(e) {

        const { event } = this.state;

        const newEvent = {
            ...event,
            [e.target.name]: e.target.checked
        };

        this.setState({
            event: newEvent
        });
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;

        const { event } = this.state;

        const newEvent = {
            ...event,
            [fieldName]: fieldValue
        };

        this.props.updateModel("eventDetail", newEvent);

        this.setState({
            event: newEvent
        });

    }

    onEventStartDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            startDate: choosed !== null ? choosed.getTime() : '',
            endDate: choosed !== null ? choosed.getTime() : ''
        };
        this.props.updateModel("eventDetail", newEvent);
        this.setState({
            event: newEvent
        });
    }

    onEventEndDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            endDate: choosed !== null ? choosed.getTime() : ''
        };
        this.props.updateModel("eventDetail", newEvent);
        this.setState({
            event: newEvent
        });
    }

    //remove this code
    handleBookingChange(e) {
        let oldEvent = this.state.event;
        let newEvent = {
            ...oldEvent,
            useBooking: e.target.value
            //eventLink:'',
            //userMinAge:'0'
        }
        this.props.updateModel("eventDetail", newEvent);

        let oldState = this.state;
        this.setState({
            ...oldState,
            // useBooking: e.target.value,
            event: newEvent
        });


    }

  
 


    render() {
        const { t } = this.props;
        const { event: { title, startDate, endDate, description, eventLink, bookingLink,  userMinAge, maxParticipants, bookingType } } = this.state;

        return (
            <div className=" justify-content-between d-relative mt-1 greyBg p-2">
                <Row>
                    <Col lg={6}>
                        <Form.Group controlId="startDate" >
                            <Form.Label htmlFor="Startdatum">{t("eventStart")}</Form.Label>
                            <DatePicker selected={startDate}
                                onChange={this.onEventStartDateChange}
                                placeholderText={t("Startdatum")}
                                minDate={new Date()}

                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="Pp"
                                locale="de"
                                className="form-control"
                                name="Startdatum"
                            />

                        </Form.Group>

                    </Col>
                    <Col lg={6}>

                        <Form.Group controlId="endDate" >
                            <Form.Label >{t("eventEnd")}</Form.Label>
                            <DatePicker selected={endDate}
                                onChange={this.onEventEndDateChange}
                                placeholderText={t("endDatum")}
                                minDate={new Date()}

                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="Pp"
                                locale="de"
                                className="form-control"
                            />
                        </Form.Group>

                    </Col>
                </Row>

                <Row>
                    <Col lg={6} md={8}>
                        <Form.Group className="mt-2 " >
                            <Form.Label htmlFor="maxParticipants">{t("eventLink")}</Form.Label>
                            <Form.Control placeholder={t("eventLink")}
                                value={eventLink} name="eventLink"
                                onChange={this.onEventInputChange} maxLength={250}/>
                        </Form.Group>
                    </Col>
                    <Col lg={6} md={8}>
                        <Form.Group className="mt-2 " >
                            <Form.Label htmlFor="userMinAge">{t("userMinAge")}</Form.Label>
                            <Form.Control value={userMinAge}
                                type="number"
                                min="1"
                                step="1"
                                name="userMinAge"
                                onChange={this.onEventInputChange}
                                id="userMinAge"
                                style={{ width: "80px" }}

                            />
                        </Form.Group>

                    </Col>

                </Row>

                <Row>
                    <Col lg={6} md={8}>
                        <Form.Group className="mt-2 " >
                            <Form.Label >{t("bookingService")} </Form.Label>
                            <Form.Control as="select" name="bookingType" value={bookingType} onChange={this.onEventInputChange} aria-describedby="bookingHelpBlock">
                                {BOOKING_TYPES.map((r, i) =>
                                    <option selected={bookingType === r.value} key={r.value} value={r.value}>{t(r.label)}</option>
                                )}

                            </Form.Control>
                        </Form.Group>

                    </Col>
                    <Col lg={6} md={8}>
                        <Form.Group className="mt-2" >
                            <Form.Label htmlFor="maxParticipants">{t("maxParticipants")}</Form.Label>
                            <Form.Control value={maxParticipants}
                                type="number"
                                min="1"
                                step="1"
                                name="maxParticipants"
                                onChange={this.onEventInputChange}
                                id="maxParticipants"
                                style={{ width: "80px" }}

                            />
                        </Form.Group>
                    </Col>

                    <Col lg={6} md={8}>
                        {bookingType === 'EXTERN' ?
                            <Form.Control placeholder={t("bookingLink")}
                                value={bookingLink} name="bookingLink"
                                onChange={this.onEventInputChange} className="mt-2" maxLength={250} />
                            :
                            ''
                        }
                        {bookingType === 'INTERN' ?
                             <Form.Text id="bookingHelpBlock" muted>
                               {t("internHelp")}
                           </Form.Text>
                            :
                           ''
                        }
                          {bookingType === 'NONE' ?
                             <Form.Text id="bookingHelpBlock" muted>
                               {t("noneHelp")}
                           </Form.Text>
                            :
                           ''
                        }
                    </Col>

                </Row>

                {(this.props.editMode) ?
                    <Row>
                        <Col lg={12} md={12}>
                            <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        {t("speichern")}
                                    </Tooltip>
                                }>
                                <Button variant="outline-primary" onClick={() => this.props.saveEvent(this.state.event)} className="float-left mt-3"><span class="fa fa-save ">&nbsp;{t("speichern")}</span></Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>

                    :
                    ""
                }



            </div>
        )
    }
}

export default translate("translations")(PublicEventAddDetail);
